var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4818 18.3327H3.51884C3.0277 18.3327 2.55668 18.1376 2.20939 17.7903C1.8621 17.443 1.66699 16.972 1.66699 16.4808V3.51787C1.66699 3.02673 1.8621 2.5557 2.20939 2.20841C2.55668 1.86112 3.0277 1.66602 3.51884 1.66602H13.704L18.3337 6.29565V16.4808C18.3337 16.972 18.1386 17.443 17.7913 17.7903C17.444 18.1376 16.9729 18.3327 16.4818 18.3327ZM4.16699 11.834C4.16699 11.2817 4.61471 10.834 5.16699 10.834H12.3337C12.8859 10.834 13.3337 11.2817 13.3337 11.834V14.834C13.3337 15.3863 12.8859 15.834 12.3337 15.834H5.16699C4.61471 15.834 4.16699 15.3863 4.16699 14.834V11.834ZM5 5.66602C4.44772 5.66602 4 6.11373 4 6.66602C4 7.2183 4.44772 7.66602 5 7.66602H12.5C13.0523 7.66602 13.5 7.2183 13.5 6.66602C13.5 6.11373 13.0523 5.66602 12.5 5.66602H5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.e8a20238d476bd7ab114af7697ab1cf2.svg";
export { ForwardRef as ReactComponent };